import type { AsyncSequence, Bytes } from "@pdfking/tfunc"

export const ResizeUInt8 = async function* (
  chunks: AsyncSequence<Uint8Array>,
  chunk_size: Bytes
): AsyncGenerator<Uint8Array> {
  let pending = new Uint8Array(chunk_size)
  let offset = 0

  for await (const chunk of chunks) {
    let chunkOffset = 0

    while (chunkOffset < chunk.length) {
      const spaceLeft = chunk_size - offset
      const remaining = chunk.length - chunkOffset

      if (remaining <= spaceLeft) {
        pending.set(chunk.subarray(chunkOffset), offset)
        offset += remaining
        break
      }

      pending.set(chunk.subarray(chunkOffset, chunkOffset + spaceLeft), offset)
      chunkOffset += spaceLeft
      yield pending

      pending = new Uint8Array(chunk_size)
      offset = 0
    }
  }

  if (offset > 0) {
    yield pending.subarray(0, offset)
  }
}
